import { render, staticRenderFns } from "./CopyProduct.vue?vue&type=template&id=6a39bba6"
import script from "./CopyProduct.vue?vue&type=script&lang=js"
export * from "./CopyProduct.vue?vue&type=script&lang=js"
import style0 from "./CopyProduct.vue?vue&type=style&index=0&id=6a39bba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports